// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';

// Utils
import { hasChanged } from '../../../../utils/react/propsComparisons';

// Components
import markSeenNotificationsConnector from './markSeenNotificationsConnector';

const nowSeenNotificationsHaveChanged = hasChanged('nowSeenNotificationIds');

/**
 * This decorator finds unseen notifications for the current board and the points of interest
 * they relate to.
 * Depending on the type of notification they will be marked as seen immediately (e.g. Share notifications),
 * or they will be marked as seen when all of the POIs for that notification have been seen.
 */
export default (DecoratedComponent) => {
    @markSeenNotificationsConnector
    class MarkSeenNotificationsDecorator extends React.Component {
        componentWillMount() {
            this.checkUnseenNotifications(this.props);
        }

        componentWillReceiveProps(nextProps) {
            if (nowSeenNotificationsHaveChanged(this.props, nextProps)) {
                this.checkUnseenNotifications(nextProps);
            }
        }

        checkUnseenNotifications = (props) => {
            const { nowSeenNotificationIds, dispatchMarkNotificationsAsSeen } = props;

            if (isEmpty(nowSeenNotificationIds)) return;

            dispatchMarkNotificationsAsSeen(nowSeenNotificationIds);
        };

        render() {
            const {
                seenPoiIds, // eslint-disable-line no-unused-vars
                dispatchMarkNotificationsAsSeen, // eslint-disable-line no-unused-vars
                nowSeenNotificationIds, // eslint-disable-line no-unused-vars
                ...rest
            } = this.props;

            return <DecoratedComponent {...rest} />;
        }
    }

    MarkSeenNotificationsDecorator.propTypes = {
        seenPoiIds: PropTypes.object,
        nowSeenNotificationIds: PropTypes.object,
        dispatchMarkNotificationsAsSeen: PropTypes.func,
    };

    return MarkSeenNotificationsDecorator;
};
